import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';
import { isDefined } from '../../../utils/variables';
import { useErrorHandling } from '../../hooks/use-error-handling';

function query() {
  return SkyMapAxiosServiceFactory.instance.createCompanyServiceV0().fetchAllCompanies({});
}

/**
 * Fetches all companies for project transfer request.
 */
export function useFetchAllCompaniesQuery() {
  const { handleError, hasError, clearErrors, buildErrorList } = useErrorHandling();

  const { data, refetch, error, isLoading } = useQuery({
    queryKey: ['fetchAllCompanies'],
    queryFn: query,
    networkMode: 'always',
    retry: false,
    refetchInterval: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // Define effect on error outside of mutation to avoid infinite render loop.
  useEffect(() => {
    if (isDefined(error)) {
      handleError(error, { retryCallback: refetch });
    } else {
      clearErrors();
    }
  }, [handleError, clearErrors, error, refetch]);

  return {
    companies: data?.data,
    buildErrorList,
    hasError,
    isLoading,
  };
}
